module.exports = __webpack_public_path__ + "static/media/RP-89.e8ecbee4.pdf";